import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";

export const getLeadInterests = async (organization_id: any, lead_id: any) => {
    let token = await getAuthToken();
    try {
        if(token){
            let header_token = "Bearer " + token.data;
            const headers = {
                Authorization: header_token,
            };
        try {
            const endpoint = `${baseUrl}/core/organizations/${organization_id}/leads/${lead_id}/interests`;
            const response = await axios.get(endpoint,{ headers });
            if (response.status>=200 && response.status <=400) {
            return {"success":true, "data": response?.data};
            } else {
            console.error("Data retrieval failed here:", response, response.data);
            return {"success":false, "data": response?.data};
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            return {"success":false, "data": error};
        }
        }else{
        return {"success":false, "data": "error: Token does not exist"};
        }
        
    }catch (error) {
        console.error("Unexpected error occurred while fetching the leads:", error);
        return {"success":false, "data": undefined};
    }
};

export const getLeadInterest = async (organization_id: any, lead_id: any, interest_id: any) => {
  let token = await getAuthToken();
  try {
      if(token){
          let header_token = "Bearer " + token.data;
          const headers = {
              Authorization: header_token,
          };
      try {
          const endpoint = `${baseUrl}/core/organizations/${organization_id}/leads/${lead_id}/interests/${interest_id}`;
          const response = await axios.get(endpoint,{ headers });
          if (response.status>=200 && response.status <=400) {
          return {"success":true, "data": response?.data};
          } else {
          console.error("Data retrieval failed here:", response, response.data);
          return {"success":false, "data": response?.data};
          }
      } catch (error) {
          console.error("An unexpected error occurred:", error);
          return {"success":false, "data": error};
      }
      }else{
      return {"success":false, "data": "error: Token does not exist"};
      }
      
  }catch (error) {
      console.error("Unexpected error occurred while fetching the lead interests:", error);
      return {"success":false, "data": undefined};
  }
};

export const saveLeadInterest = async (
  orgId: string,
  leadId: string,
  interest_id: string,
) => {
  const leadInterest = {
    interest_id,
  };
  let token = await getAuthToken();
  let headers;

  if(token){
    let header_token = "Bearer " + token.data;
    headers = {
        Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/leads/${leadId}/interests/`;
    const response = await axios.post(endpoint, leadInterest, {headers});

    if (response.status === 201) {
      console.log("Lead Note created successfully:", response.data);
      return { success: true, data: response.data };
    } else {
      console.error("Failed to create lead note:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error("An unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};

export const deleteLeadInterest = async (orgId: string, leadId: string, interestId: string) => {
  let token = await getAuthToken();
  let headers;

  if(token){
    let header_token = "Bearer " + token.data;
    headers = {
        Authorization: header_token,
    };
  }
    try {
      const endpoint = `${baseUrl}/core/organizations/${orgId}/leads/${leadId}/interests/${interestId}/`;
      const response = await axios.delete(endpoint, {headers});
  
      if (response.status === 204) {
        console.log("Lead deleted successfully");
        return { success: true, data: "Lead Note deleted successfully" };
      } else {
        console.warn("Unexpected response status:", response.status);
        return { success: false, data: response.data };
      }
    } catch (error: any) {
      console.error("Error deleting lead note:", error?.response?.data || error);
      return { success: false, data: error?.response?.data || error };
    }
  };